import './CommentLine.css'
import React from 'react'
import CommentLineDownward from './CommentLineDownward'
import CommentLineUpward from './CommentLineUpward'
import CommentLineStraight from './CommentLineStraight'
import { DEFAULT_LINE_WIDTH, COMMENT_LINE_TOP_OFFSET } from '../constants'

export default function CommentLine({
  pageHeight,
  rect,
  managedTop,
  currentScrollTop,
  isAutomaticallyScrollingComments,
  annotationId,
  isSelected,
  viewportWidth,
  widthExtension,
}) {
  const height = managedTop - rect[1][1] - currentScrollTop

  if (height >= DEFAULT_LINE_WIDTH) {
    const heightFromAnnotationToBottom = pageHeight - rect[1][1]
    const commentLineDownwardHeightTruncated =
      heightFromAnnotationToBottom < height
        ? heightFromAnnotationToBottom - COMMENT_LINE_TOP_OFFSET / 2
        : height
    return (
      isAutomaticallyScrollingComments === false && (
        <CommentLineDownward
          annotationId={annotationId}
          height={commentLineDownwardHeightTruncated}
          isSelected={isSelected}
          rect={rect}
          viewportWidth={viewportWidth}
          widthExtension={widthExtension}
        />
      )
    )
  } else if (height < -DEFAULT_LINE_WIDTH) {
    const commentLineUpwardHeight = rect[1][1] - managedTop + currentScrollTop
    const commentLineUpwardHeightTruncated =
      rect[1][1] < commentLineUpwardHeight ? rect[1][1] : commentLineUpwardHeight
    const managedTop2 = managedTop - currentScrollTop
    return (
      isAutomaticallyScrollingComments === false && (
        <CommentLineUpward
          annotationId={annotationId}
          managedTop={
            managedTop2 < -COMMENT_LINE_TOP_OFFSET ? -COMMENT_LINE_TOP_OFFSET : managedTop2
          }
          height={commentLineUpwardHeightTruncated}
          isSelected={isSelected}
          rect={rect}
          viewportWidth={viewportWidth}
          widthExtension={widthExtension}
        />
      )
    )
  } else {
    return (
      <CommentLineStraight
        annotationId={annotationId}
        height={height}
        isSelected={isSelected}
        rect={rect}
        viewportWidth={viewportWidth}
        widthExtension={widthExtension}
      />
    )
  }
}
